<template>
	<el-drawer size="35%" title="详情" :visible.sync="dialogVisible" :modal-append-to-body="false" direction="rtl" :wrapperClosable="true"
		class="customer-drawer-common open-type-platform">
		<el-form ref="form" :model="form" label-width="120px">
			<el-form-item label="AppID">
				<el-input  v-model="form.appid" disabled placeholder="AppID"></el-input>
			</el-form-item>
			<el-form-item label="昵称" >
				<el-input  v-model="form.nickname" placeholder="昵称" disabled></el-input>
			</el-form-item>
			<el-form-item label="原始名称">
				<el-input  v-model="form.username" placeholder="原始名称" disabled></el-input>
			</el-form-item>
			<el-form-item label="主体名称">
				<el-input  v-model="form.principalname" placeholder="主体名称" disabled></el-input>
			</el-form-item>
			<el-form-item label="公众号二维码">
				  <!-- <el-image style="width: 100px; height: 100px" :src="form.qrcodeurl"
				  :preview-src-list="[form.qrcodeurl]" referrer-policy="no-referrer">
				  </el-image> -->
				  <div v-html="showImg(form.qrcodeurl)" @click="test()"></div>
				 
			</el-form-item>
			<el-form-item label="AccessToken">
				 <el-input placeholder="AccessToken" v-model="form.accesstoken" disabled>
				    <el-button slot="append" class="primary-refresh">刷新</el-button>
				  </el-input>
			</el-form-item>
			<el-form-item label="RefreshToken">
				<el-input  v-model="form.refreshtoken" placeholder="RefreshToken" disabled></el-input>
			</el-form-item>
		</el-form>
		<!-- 权限集列表 appidFunc-->
		<section>
			<p>权限集列表</p>
			<table-pagination  :data="form.appidFunc" :column="column" class="infinite-list"></table-pagination>
		</section>
		<div class="footer-btn">
			<el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
		</div>
	</el-drawer>
</template>

<script>
	export default {
		data(){
			return {
				dialogVisible:false,
				form: {
					appid:'',
					nickname:'',
					username:'',
					principalname:'',
					qrcodeurl:'',
					accesstoken:'',
					refreshtoken:'',
					appidFunc:[]
				},
				column:[{
					label: "权限集ID",
					prop: "funcid",
				},{
					label: "名称",
					prop: "funcname",
					render:(h,scope)=>{
						return <span>{scope.row.funcname || 'null'}</span>
					}
				}]
			}
		},
		methods:{
			 showImg(url) {
				if(url){
					var frameid = 'frameimg' + Math.random();
					//<script>window.onload = function() { parent.document.getElementById(\'' + frameid + '\').height = document.getElementById(\'img\').height+\'px\'; }<' + '/script>
					window.img = '<img id="img" style="width:150px" src=\'' + url + '?' + Math.random() + '\' />';
					return ('<iframe id="' + frameid + '" src="javascript:parent.img;" frameBorder="0" scrolling="no" width="150px"></iframe>');
				}
			},
			onOpen(row){
				this.dialogVisible = true
				this.$api.getWechatSystemOpenTypePlatform(row.appid).then(res => {
					if(res.errcode == 0) {
						if(res.data.appidDetail) {
							Object.keys(this.form).map(item => {
								this.form[item] = res.data.appidDetail[item]
							})
						}
						this.form.appidFunc = res.data.appidFunc;
					}
				})
			},
			test(){
				console.log('test')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.open-type-platform {
		.footer-btn {
			display: flex;
			justify-content: flex-end;
			align-items:center;
			margin: 20px 0;
		}
		.primary-refresh {
			background-color: #409EFF;
			color: #fff;
		}
		p {
			color: #606266;
			font-weight: 700;
		}
	}
</style>
